import "core-js/full/typed-array/to-hex";

declare global {
  interface Uint8Array {
    toHex(): string;
  }
}

namespace UCrypto {
  const textEncoder = new TextEncoder();

  export const sha256Hex = (input: string | undefined) =>
    crypto.subtle
      .digest("SHA-256", textEncoder.encode(input))
      .then((buffer) => new Uint8Array(buffer).toHex());
}

export default UCrypto;
